import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Panel } from '@ipc/ipc-components';

import { PanelContent } from '../../../styles';
import { FormLabel, DayPickerInput } from '../../../elements';
import { addMonthsToDate, stringToDate } from '../../../utils/date';

const ReportingDateRangeComponent = ({ values, validations, dateChangeHandler }) => {
  const [maxDate, setMaxDate] = useState(addMonthsToDate(values.reportingStartDate, 3));

  const getDayPickerProps = () => ({
    disabledDays: {
      before: stringToDate(values.reportingStartDate),
      after: maxDate.toDate(),
    },
  });

  const handleStartDateChanged = name => (selectedDay, modifiers, dayPickerInput) => {
    dateChangeHandler(name)(selectedDay, modifiers, dayPickerInput);
    setMaxDate(addMonthsToDate(selectedDay, 3));
  };

  return (
    <Panel title="Reporting Date" expanded>
      <PanelContent>
        <div className="FormRow">
          <div className="FormRowInline">
            <FormLabel title="Reporting Start Date" required forDayPicker hasError={!validations.reportingStartDate}>
              <DayPickerInput
                name="reportingStartDate"
                value={values.reportingStartDate}
                onChange={handleStartDateChanged('reportingStartDate')}
              />
            </FormLabel>
          </div>

          <div className="FormRowInline">
            <FormLabel title="Reporting Stop Date" required forDayPicker hasError={!validations.reportingStopDate}>
              <DayPickerInput
                name="reportingStopDate"
                value={values.reportingStopDate}
                onChange={dateChangeHandler('reportingStopDate')}
                dayPickerProps={getDayPickerProps()}
              />
            </FormLabel>
          </div>
        </div>
      </PanelContent>
    </Panel>
  );
};

ReportingDateRangeComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  dateChangeHandler: PropTypes.func,
};

export default ReportingDateRangeComponent;
